import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homenine-blog',
  templateUrl: './homenine-blog.component.html',
  styleUrls: ['./homenine-blog.component.scss']
})
export class HomenineBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
